import { cx } from "../../Utils/helpers";

const getInitials = (name = "") =>
  name
    .split(" ")
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

/** Gradient initials placeholder — swap for a real <img src> once photos exist. */
function Avatar({ name, size = "md", className }) {
  return (
    <span className={cx("avatar", `avatar--${size}`, className)} aria-hidden="true">
      {getInitials(name)}
    </span>
  );
}

export default Avatar;
